










    import Vue from 'Vue';

    export default Vue.extend({
        name:'activity-snackbar',
        data(): any {
            return { show: false, message: '', timeout: -1 }
        },
        created (): void {
            this.$store.watch(state => state.ui.activityMessage,
                () => {
                    const msg = this.$store.state.ui.activityMessage;
                    this.message = msg;
                    if (msg !== '') {
                        this.show = true;
                    } else {
                        this.show = false;
                    }
                });
        }
    });
